










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { EErrorType } from '@/helpers/enums';

import TraceableError from '@/classes/TraceableError';
import { ICheckoutCartOffer } from '@/interfaces/Checkout';

import OtherPaymentMethods from './OtherPaymentMethods.vue';
import SuggestedOffer from './SuggestedOffer.vue';
import { sendInteractEvent } from '@/helpers/events';
import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    OtherPaymentMethods,
    SuggestedOffer,
  }
})
export default class ErrorInfo extends Vue {
  @Prop()
  private error: TraceableError;

  @CheckoutModule.Getter
  private suggestedOffer: ICheckoutCartOffer | null;

  @Watch('error', { immediate: true })
  private sendErrorEvent(error: TraceableError) {
    if (
      (error && error.code == 1100) ||
      (error && error.code == 1101) ||
      (error && error.code == 1102) ||
      (error && error.code == 1103) ||
      (error && error.code == 1104)
    )
      sendInteractEvent({
        action: EInteractEventTrackerAction.CHK_SHOW_RECOMMENDATION_LA,
        attributes: {
          recommended_content_url: process.env.VUE_APP_DASHBOARD_URL,
        }
      });
  }

  private get imgPath() {
    const { informative } = this.error;

    if (!informative) {
      return require('@/assets/images/errors/algo-deu-errado.png');
    }

    return require(`@/assets/images/errors/${informative.image}`);
  }

  private get showSuggestedOffer(): boolean {
    return [EErrorType.availability, EErrorType.eligibility].includes(this.error.type)
      && !!this.suggestedOffer;
  }
}
